import { SearchFormInputs } from "src/Modules/Hotels/constants/SearchPage";
import { GuestClassificationType, GuestsInputType } from "src/Modules/Hotels/constants/HotelBooking";
import { TFunction } from "i18next";

type Guest = {
  key: string;
  type: GuestClassificationType;
  label: string;
  indexInType: number;
  roomIndex: number;
  age?: number;
};

const buildGuestsList = (searchObject: SearchFormInputs, t: TFunction): Guest[] => {
  const rooms = searchObject?.rooms ?? [];
  const adults: Omit<Guest, "label">[] = [];
  const children: Omit<Guest, "label">[] = [];

  rooms.forEach((room, roomIndex) => {
    for (let i = 0; i < room.adults; i++) {
      adults.push({
        key: `room_${roomIndex}_adult_${i}`,
        type: "adult",
        indexInType: adults.length,
        roomIndex,
      });
    }
    for (let i = 0; i < room.children; i++) {
      children.push({
        key: `room_${roomIndex}_child_${i}`,
        type: "child",
        indexInType: children.length,
        roomIndex,
        age: room.childrenAges?.[i],
      });
    }
  });

  return [...adults, ...children].map((guest, index) => ({
    ...guest,
    label: t("Hotels.guests.guestNumber", { number: index + 1 }),
  }));
};

const generateInitialGuestValues = (guests: Guest[], existingGuestValues: GuestsInputType, primaryGuestKey: string | null): GuestsInputType => {
  const soleAdultKey = guests.filter((guest) => guest.type === "adult").length === 1 ? guests.find((guest) => guest.type === "adult")?.key : undefined;

  return guests.reduce<GuestsInputType>((acc, guest) => {
    const existing = existingGuestValues[guest.key];
    const isLeadGuest = existing?.isLeadGuest ?? (soleAdultKey ? guest.key === soleAdultKey : guest.key === primaryGuestKey);
    acc[guest.key] = {
      ...existing,
      isLeadGuest: guest.type === "adult" ? isLeadGuest : undefined,
    };
    return acc;
  }, {});
};

export { buildGuestsList, generateInitialGuestValues };
export type { Guest };
